import BusinessErrorEnum from "@/src/domain/enums/business-error-enum";

export class BusinessException extends Error {
  public readonly type: BusinessErrorEnum;

  constructor(
    messageOrEnum: string | BusinessErrorEnum,
    cause?: unknown,
    type?: BusinessErrorEnum
  ) {
    const isString = typeof messageOrEnum === "string";
    let message: string;
    if (isString) {
      message = messageOrEnum;
    } else {
      message = BusinessErrors[messageOrEnum].message;
    }
    super(message, { cause });
    this.name = "BusinessException";
    Object.setPrototypeOf(this, BusinessException.prototype);
    this.type = isString ? (type ?? BusinessErrorEnum.ETC) : messageOrEnum;
  }
}

const BusinessErrors: Record<BusinessErrorEnum, { message: string }> = {
  [BusinessErrorEnum.InvalidInput]: {
    message: "The input provided is invalid.",
  },
  [BusinessErrorEnum.Unauthorized]: {
    message: "You are not authorized to perform this action.",
  },
  [BusinessErrorEnum.NotFound]: {
    message: "The requested resource was not found.",
  },
  [BusinessErrorEnum.PasswordUpdateFailed]: {
    message: "Failed to update the password.",
  },
  [BusinessErrorEnum.RefreshTokenFailed]: {
    message: "Failed to refresh the token.",
  },
  [BusinessErrorEnum.ETC]: { message: "An unknown error occurred." },
  [BusinessErrorEnum.UserInfoLoadFailed]: {
    message: "Failed to load user information.",
  },
  [BusinessErrorEnum.AccountDeletionAlreadyScheduled]: {
    message: "Account deletion has already been scheduled.",
  },
  [BusinessErrorEnum.UserHasNoDevices]: {
    message: "No devices associated with this account.",
  },
};
